<template>
  <div id="career">
     <popup v-if="ContentModal" :pakketData="ContentModal" /> 
    <!-- <canvas></canvas> -->
    <main id="main" data-page-id="home">
      <section class="innerpage_header" data-scroll-section="h1">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>
        <div class="innerpage_header_textbox">
          <h1> Career</h1>
        </div>

        <a class="next_slide" v-on:click="NextSlide()">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" width="60px" height="60px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;"
            xml:space="preserve">

            <defs>
            </defs>
            <path class="st0" d="M60,30C60,13.5,46.5,0,30,0S0,13.5,0,30s13.5,30,30,30S60,46.5,60,30z M29.2,45.6l-15-22
            C14.1,23.4,14,23.2,14,23c0-0.2,0-0.3,0.1-0.5c0.2-0.3,0.5-0.5,0.9-0.5h30c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.2,0.7-0.1,1l-15,22
            C30.6,45.8,30.3,46,30,46S29.4,45.8,29.2,45.6z" />
          </svg>

        </a>
      </section>


      <section class="about centerRow s2" data-scroll-section="h2">
        <div class="container">
          <div class="row center-xs">
            <div class="col-xs-7">
              <div class="box">
                <h3>
                  FIND YOUR FUTURE
                </h3>
                <p>
        MI loves to empower employees. <br>
For individuals who are ambitious and hardworking, the opportunities to grow in their careers are boundless. The true reality is that in most workplaces, management is not connected to its employees on a fundamental working level. However, at MI, our members get treated with humanity, dignity, and transparency. Management touches the  hearts of our members, by working side by side not above and below each other on projects and allowing them to take leadership roles in projects to learn, gain practical knowledge and skills, and become well rounded leaders.


                </p>
              </div>
            </div>
          </div>

        </div>

      </section>

      <section class="careertable" data-scroll-section="h3">
        <div class="container">

          <h4>OPEN POSITIONS IN ALL DEPARTMENTS
          </h4>
          <div class="career">
            <div class="career__header ">
              <div class="career__header__th cr_col">
                JOB TITLE
              </div>
              <div class="career__header__th cr_col">
                LOCATION
              </div>
              <div class="career__header__th cr_col">
                EMPLOYMENT TYPE
              </div>
            </div>
            <div class="career__body">
              <div class="career__body__item" @click="ContentModal=item" v-for="item in dataCareer">
                <div class="career__body__th cr_col">
                  {{item.title}}
                </div>
                <div class="career__body__th cr_col">
                    {{item.location}}
                </div>
                <div class="career__body__th cr_col">
                  {{item.type}}
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>





      <section class="started-section">
        <div class="container row started__container">
          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">this is where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <router-link  class="button button--white-hover-trans pulse" to="/contact">Contact</router-link>
              <a href="https://web.mobilityintel.com" class="button button--transparent pulse">get started</a>
            </div>
          </div>
        </div>
      </section> 


      <section class="o-eric-progress e-scrol">
        <div class="c-eric-progress-container">
          <div class="c-eric-progress">
            <div class="c-eric-progress__counter">
              <div class="c-eric-progress__counter-zero">0</div>
              <div class="c-eric-progress__counter-item">

              </div>
            </div>
            <div class="c-eric-progress-el">

            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import EventBus from '@/event-bus';
  import JQuery from 'jquery';
  // import Canvasjs from '@/canvas'
  import flexbox from 'flexboxgrid';
  import global from '@/mixins/global';
  import jsonData from '../../assets/data/data.json';
  import popup from '@/components/popup/';
  import axios from 'axios';

  export default {
    name: 'Career',
    data() {
      return {
           ContentModal:undefined,
           dataCareer: undefined
      };
    },
    // components: { Header},
    mixins: [global],
    metaInfo: {
      title: 'Career',
    },
    methods: {
      NextSlide() {
        var val = $("section.s2").offset().top;
        console.log("data-scroll =", val);
        window.scrollTo({
          top: val,
          behavior: 'smooth'
        });
      }
,

    },
    mounted() {
       
            this.dataCareer = jsonData.data;
      // var dataJson = '{ "data":[ { "id":1, "fileurl":"https://res.cloudinary.com/dezkbyau1/raw/upload/v1607642668/Data_Analysis_Specialist_qsdqdd.html", "title":"Avionics Development Technician1", "location":"NJ, United States1", "type":"EMPLOYMENT TYPE1" }, { "id":2, "fileurl":"https://res.cloudinary.com/dezkbyau1/raw/upload/v1607642668/Data_Analysis_Specialist_qsdqdd.html", "title":"Avionics Development Technician2", "location":"NJ, United States2", "type":"EMPLOYMENT TYPE2" }, { "id":3, "fileurl":"https://res.cloudinary.com/dezkbyau1/raw/upload/v1607642668/Data_Analysis_Specialist_qsdqdd.html", "title":"Avionics Development Technician3", "location":"NJ, United States3", "type":"EMPLOYMENT TYPE3" }, { "id":4, "fileurl":"https://res.cloudinary.com/dezkbyau1/raw/upload/v1607642668/Data_Analysis_Specialist_qsdqdd.html", "title":"Avionics Development Technician4", "location":"NJ, United States4", "type":"EMPLOYMENT TYPE4" } ] }';
      //   console.log(JSON.parse(dataJson) );
        EventBus.$on('open-modal', (assortment) => {
          this.ContentModal = assortment;
          // console.log(assortment);
        });
        EventBus.$on('close-modal', () => {
          this.ContentModal = undefined;
        });
  

    },
    components:{popup}
  };

</script>
<style src='@fancyapps/fancybox/dist/jquery.fancybox.css'></style>
<style lang="scss">
  // @import("@fancyapps/fancybox/")
  @import './style.scss';
div#vjs-tab-job img {
    display: none;
}
div#vjs-tab-job * {
  font-family: 'Roboto' !important;
}

.header__jobfile {
    overflow: hidden;
}

h1.header__jobfile__title {}

h1.header__jobfile__Department {
    float: right;
}

h1.header__jobfile__title {
    float: left;
}
.header__jobfile h1, .body__jobfile h1 {
    font-size: 23px;
}

.body__jobfile {}
</style>



// WEBPACK FOOTER //
// src/components/Career/index.vue